import React from "react";
import Navbar from "../components/ui/Navbar";
import Footer from "../components/ui/Footer";
import { Card, CardContent, CardHeader } from "../components/ui/card";
import { LucideServer, LucideCloud, LucideShield, LucideZap, LucideDatabase, LucideBarChart } from "lucide-react";

const projects = [
  {
    title: "Enterprise Azure Tenant Setup",
    description: "Configured and deployed a secure multi-tenant Azure environment with role-based access control, compliance policies, and cost optimization.",
    tech: "Azure AD, Microsoft Entra, Intune, Compliance Center, Defender for Endpoint",
    icon: <LucideCloud className="h-10 w-10 text-blue-600" />
  },
  {
    title: "Office 365 Email Migration",
    description: "Migrated 500+ users from on-premises Exchange to Microsoft 365 with zero downtime and post-migration support.",
    tech: "Exchange Online, Microsoft 365, Hybrid Deployment, PowerShell Automation",
    icon: <LucideServer className="h-10 w-10 text-blue-600" />
  },
  {
    title: "Defender & Security Hardening",
    description: "Implemented Microsoft Defender across endpoints, configured SIEM monitoring, and enforced compliance policies for regulated industries.",
    tech: "Microsoft Defender for Endpoint, Sentinel, Azure Security Center",
    icon: <LucideShield className="h-10 w-10 text-blue-600" />
  },
  {
    title: "Custom Web App for Logistics Management",
    description: "Developed a full-stack web app for real-time tracking of inventory, automated invoicing, and reporting.",
    tech: "React, FastAPI, PostgreSQL, Azure App Services",
    icon: <LucideZap className="h-10 w-10 text-blue-600" />
  },
  {
    title: "Automated Power Automate Workflows",
    description: "Built automation workflows for HR onboarding, document approvals, and email alerts, reducing manual workload by 60%.",
    tech: "Power Automate, SharePoint, Azure Logic Apps, Python",
    icon: <LucideBarChart className="h-10 w-10 text-blue-600" />
  },
  {
    title: "Oracle & Azure SQL Database Migration",
    description: "Migrated an enterprise Oracle database to Azure SQL, optimizing performance and reducing costs by 30%.",
    tech: "Oracle DB, Azure SQL, Fabric, Data Factory",
    icon: <LucideDatabase className="h-10 w-10 text-blue-600" />
  }
];

const reviews = [
  {
    name: "Michael Carter",
    position: "IT Director, TechWave Inc.",
    review: "Query Minds transformed our cloud infrastructure. Their expertise in Azure and security was top-notch. Highly recommend!"
  },
  {
    name: "Sophia Patel",
    position: "CEO, Digital Logistics",
    review: "The custom web app built by Query Minds completely streamlined our operations. Fantastic team and great support!"
  },
  {
    name: "James Roberts",
    position: "CISO, SecureCom",
    review: "Their cybersecurity services helped us meet compliance and mitigate risks effectively. Best decision we made!"
  }
];

const ProjectsPage = () => (
  <div className="flex flex-col min-h-screen bg-gray-50">
    {/* Navbar */}
    <Navbar />

    {/* Main Content */}
    <div className="flex-grow container mx-auto py-20 px-4">
      <h1 className="text-5xl font-bold text-center text-blue-600 mb-10">Our Successful Projects</h1>

      {/* Projects Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects.map((project, index) => (
          <Card key={index} className="shadow-lg hover:shadow-xl transition-shadow duration-300">
            <CardHeader className="flex justify-center items-center p-6">
              {project.icon}
            </CardHeader>
            <CardContent className="p-4 text-center">
              <h3 className="text-xl font-bold mb-3 text-gray-800">{project.title}</h3>
              <p className="text-gray-600">{project.description}</p>
              <p className="text-sm text-blue-500 mt-2">Tech Used: {project.tech}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Reviews Section */}
      <h2 className="text-4xl font-bold text-center text-blue-600 mt-16 mb-8">Client Testimonials</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {reviews.map((review, index) => (
          <Card key={index} className="shadow-md hover:shadow-lg transition-shadow duration-300">
            <CardContent className="p-6 text-center">
              <p className="text-gray-700 italic">"{review.review}"</p>
              <h4 className="text-lg font-semibold text-blue-600 mt-4">{review.name}</h4>
              <p className="text-gray-500 text-sm">{review.position}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>

    {/* Footer */}
    <Footer />
  </div>
);

export default ProjectsPage;
